import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { Document360_widgetformComponent } from './Document360.widgetform.component';


@Injectable({ providedIn: 'root' })
export class Document360_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
  ) {
    super(dialog, toastr);
  }

  public Document360: Document360_ShellService = this;

  public openwidgetform(replaceCurrentView?: boolean) {
    this.$logger.log('Document360', 'widgetform');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'widgetForm',
        referenceName: 'Document360_widgetform',
        component: Document360_widgetformComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openwidgetformDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('Document360', 'widgetform');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      Document360_widgetformComponent,
      'widgetForm',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'Document360_widgetform') {
      this.$logger.log('Document360', 'widgetform');
      const title = 'widgetForm';
      const component = Document360_widgetformComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    return result;
  }
}
